import React, { useState, useEffect } from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { tesoroData } from '../mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';


const TesoroSection = () => {
  const [selectedProject, setSelectedProject] = useState(null)
  const openModal = (project) => {
    setSelectedProject(project)
  }

  const closeModal = () => {
    setSelectedProject(null)
  }
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") {
        closeModal()
      }
    }

    window.addEventListener("keydown", handleKey)

    return () => {
      window.removeEventListener("keydown", handleKey)
    }
  }, [])
  return (
    <>
      <section id="tesoro" className="py-24 bg-gradient-to-b from-gray-950 to-black relative overflow-hidden">
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-green-500/5 rounded-full blur-3xl"></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <div className="flex items-center justify-center gap-3 mb-4">
                <Star className="text-yellow-400" size={32} fill="currentColor" />
                <h2 className="text-4xl md:text-5xl font-bold text-green-400 font-mono">
                  {'<'} {tesoroData.title} {'/>'}
                </h2>
                <Star className="text-yellow-400" size={32} fill="currentColor" />
              </div>
              <p className="text-gray-400 text-lg font-mono">{tesoroData.subtitle}</p>
            </div>

            <div className="space-y-8">
              {tesoroData.items.map((item, index) => (
                <Card
                  key={item.id}
                  className="bg-gray-900/50 border-green-500/30 hover:border-green-400 transition-all duration-300 overflow-hidden group"
                  style={{ animationDelay: `${index * 150}ms` }}
                >
                  <div className="grid md:grid-cols-1 gap-6">
                    {/* <div className="grid md:grid-cols-5 gap-6"> ESTE ES EL DIV PARA UNA IMAGEN EN EL CARD
                    {/* Image */}
                    {/* <div className="md:col-span-2 relative overflow-hidden h-64 md:h-auto">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/50"></div>
                      <div className="absolute top-4 left-4">
                        <Badge className="bg-green-500 text-black font-mono font-bold text-lg px-4 py-1">
                          {item.year}
                        </Badge>
                      </div>
                    </div> */}

                    {/* Content */}
                    <div className="md:col-span-3 p-6 flex flex-col justify-center">
                      <CardHeader className="p-0 mb-4">
                        <CardTitle className="text-2xl md:text-3xl text-green-400 font-mono group-hover:text-green-300 transition-colors">
                          {item.title}
                        </CardTitle>
                      </CardHeader>

                      <CardContent className="p-0">
                        <CardDescription className="text-gray-300 text-lg mb-6 text-justify">
                          {item.description}
                        </CardDescription>

                        <div className="flex flex-wrap gap-2 mb-6">
                          {item.tech.map((tech) => (
                            <Badge
                              key={tech}
                              variant="outline"
                              className="border-green-500/50 text-green-400 font-mono"
                            >
                              {tech}
                            </Badge>
                          ))}
                        </div>

                        {/* <button className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 font-mono font-bold transition-colors group"> */}
                        <button
                          onClick={() => openModal(item)}
                          className="mt-4 text-green-400 border border-green-400 px-3 py-1 hover:bg-green-400 hover:text-black transition"
                        >
                          Ver proyecto
                          <ExternalLink size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                        </button>
                      </CardContent>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>


      {
        selectedProject && (
          <div className="fixed inset-0 bg-black/70 backdrop-blur-md flex items-center justify-center z-50" onClick={closeModal}>

            <div className="bg-gray-900 rounded-xl max-w-4xl w-full p-6 relative max-h-[90vh] overflow-hidden">

              <button
                onClick={closeModal}
                className="absolute top-3 right-4 text-gray-400 hover:text-white text-xl"
              >
                ✕
              </button>

              <h2 className="text-2xl font-bold mb-4 text-green-400">
                {selectedProject.title}
              </h2>

              <img
                src={selectedProject.image}
                alt={selectedProject.title}
                className="w-full max-h-[68vh] object-contain rounded-lg transition-transform duration-500 hover:scale-105"
              />
              <Badge className="mb-3 bg-green-500 text-black font-mono">
                {selectedProject.year}
              </Badge>
              {/* <p className="text-gray-300">
                {selectedProject.description} //aca muestra la descripcion dentro del modal, por ahora la saco
              </p> */}

            </div>

          </div>
        )
      }
    </>
  );
}
export default TesoroSection;